import { render, staticRenderFns } from "./split-filter.vue?vue&type=template&id=834ccc3a"
import script from "./split-filter.vue?vue&type=script&lang=js"
export * from "./split-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports